import ErrorDetail from "./ErrorDetail"
import EntityDetail from "./EntityDetail"
import Panel from "../../../layout/Panel"
import { observer } from "mobx-react-lite"
import { store } from "../../../../stores/Store"
import { CircularProgress } from "@mui/material"
import PanelBody from "../../../layout/PanelBody"
import PlaceholderDetail from "./PlaceholderDetail"
import PanelLabel from "../../../layout/PanelLabel"
import PanelHeader from "../../../layout/PanelHeader"
import EnquiryDetail from "./enquiry/EnquiryDetail"
import AutomationDetail from "./automation/AutomationDetail"
import CaseDetail from "./case/CaseDetail"


export interface DetailPanelProps {
    index: number;
}


export default observer(function DetailPanel () {  

    const { loadingLeafNode, leafNode, folderNode } = store.NodeStore

    const index = store.QuestionStore.showQuestionPanel ? 2 : 1

    if (loadingLeafNode) {
        return (
            <Panel index={index} id="DETAIL" className="detail" width="100%" loadingContent={loadingLeafNode}>
                <PanelLabel title={<CircularProgress style={{width: "10px", height: "10px", margin: 0}} />} />
                <PanelHeader></PanelHeader>
                <PanelBody></PanelBody>
            </Panel>
        )
    }

    const showCaseNode = !leafNode && folderNode?.typeName === "Aora.Platform.Data.CaseNode"
    const accountPreferences = store.AppStore.sessionInfo.accountPreferences
    
    if (showCaseNode && (accountPreferences?.default_case_workflow !== "NONE" || accountPreferences?.integration_api_enabled || accountPreferences?.show_optional_case_properties)) {
        return <CaseDetail index={index} key={folderNode?.uid} />
    }

    if (!leafNode) {
        return <PlaceholderDetail />
    }

    switch (leafNode.typeName)
    {
        case "Aora.Nationality.Data.SponsorNode":
        case "Aora.Nationality.Data.PersonNode":
        case "Aora.Nationality.Data.JobNode":
            return <EntityDetail index={index} />
        case "Aora.Platform.Data.EnquiryNode":
            return <EnquiryDetail index={index} />
        case "Aora.Platform.Data.AutomationNode":
            return <AutomationDetail index={index} />
        default:
            return <ErrorDetail index={index} />
    }       
})